import Vue from 'vue';
import Vuex from 'vuex';

import * as ErrorStore from './modules/error';
import * as RegisterStore from './modules/register';
import * as UiStore from './modules/ui';
import APIPlugin from './plugins/api';

Vue.use(Vuex);

export interface RootState {
  [ErrorStore.namespace]: ErrorStore.State;
  [RegisterStore.namespace]: RegisterStore.State;
  [UiStore.namespace]: UiStore.State;
}

export default new Vuex.Store({
  plugins: [APIPlugin()],
  modules: {
    [ErrorStore.namespace]: ErrorStore.module,
    [RegisterStore.namespace]: RegisterStore.module,
    [UiStore.namespace]: UiStore.module,
  },
});
